export default __webpack_public_path__ + "03f0f0f5edd92d1c65f6c534e6a15b84.png";